import { Component, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-loans-dasboard',
  templateUrl: './loans-dasboard.component.html',
  styleUrls: ['./loans-dasboard.component.scss']
})
export class LoansDasboardComponent implements OnInit {

  contractsByMonth : number[] = [];
  deniedContractsByMonth : number[] = [];

  barChartOptions: EChartsOption;
  pieChartOptions: EChartsOption;

  companies: any;
  cancelContractsByMonth: number[] = [];
  allContracts: any;

  constructor(private authServ: AuthenticationService) { }

  ngOnInit(): void {
    // this.pieChart();
    this.getContracts();
  }

  pieChart(){
    
  }

  getContracts(){
    this.authServ.getLoanContracts().then((res:any)=>{
      console.log(res);
      //added/
      // let userId = this.authServ.getUserId();
      // let userRole = this.authServ.getUserRole();
      // console.log(userRole);
      // console.log(userId);
      // if(userRole == "producer"){
      //   res = res.filter((x:any)=> x.idProducer == userId);
      // }
      //added-end
      this.allContracts = res;
      let approvedContract = res.filter((x:any)=>x.isApproved);
      console.log(res);
      let canceledContracts = res.filter((x:any)=> x.active == false);
      let deniedContracts = res.filter((x:any)=> x.isApproved == false);
      console.log(deniedContracts);
      console.log(approvedContract);
      let today = new Date();

      for(let i=0; i<12;i++){
        let monthQty = canceledContracts.filter((x: { createdDate: any; }) => new Date(x.createdDate).getMonth() == i && new Date(x.createdDate).getFullYear() == today.getFullYear()).length;
        // console.log(monthQty);
        if(Array.isArray( this.cancelContractsByMonth)){
          this.cancelContractsByMonth.push(monthQty);
        }
      }

      for(let i=0; i<12;i++){
        let monthQty = approvedContract.filter((x: { createdDate: any; }) => new Date(x.createdDate).getMonth() == i && new Date(x.createdDate).getFullYear() == today.getFullYear()).length;
        // console.log(monthQty);
        if(Array.isArray( this.contractsByMonth)){
          this.contractsByMonth.push(monthQty);
        }
      }

      for(let i=0; i<12;i++){
        let monthQty = deniedContracts.filter((x: { createdDate: any; }) => new Date(x.createdDate).getMonth() == i && new Date(x.createdDate).getFullYear() == today.getFullYear()).length;
        // console.log(monthQty);
        if(Array.isArray( this.deniedContractsByMonth)){
          this.deniedContractsByMonth.push(monthQty);
        }
      }
      

      this.authServ.getCompanies().then((res2:any)=>{
        console.log(res2);
        let comp = res2.filter((x:any)=> x.isLoan);
        console.log(comp);
        this.companies = comp.map((company: any) => {
          return {value: 0, name: company.name, id: company.id}
        });
        console.log(this.companies);
        for(let i=0; i<this.companies.length; i++){
          let companyQty = res.filter((contract:any)=> contract.compServicioId == this.companies[i].id).length;
          this.companies[i].value = companyQty;
        }
        this.createCharts();
        console.log(this.companies);
        
      })

      // console.log(this.contractsByMonth);
      
      
    })
  }

  updatePie(data:any){
    let contracts;
    if(data == "all"){
      contracts = this.allContracts;
    }
    if(data == "approved"){
      contracts = this.allContracts.filter((x:any)=> x.isApproved == true);
    }
    if(data == "cancelled"){
      contracts = this.allContracts.filter((x:any)=> x.active == false);
    }
    if(data == "denied"){
      contracts = this.allContracts.filter((x:any)=> x.isApproved == false);
    }
    for(let i=0; i<this.companies.length; i++){
      let companyQty = contracts.filter((contract:any)=> contract.compServicioId == this.companies[i].id).length;
      this.companies[i].value = companyQty;
    }

    this.createCharts();
  }

  createCharts(){
    console.log('hi');
    this.barChartOptions = {
      color: ['#3398DB','#dc3545', '#666'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          data: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
        },
      ],
      series: [
        {
          name: 'Aprobados',
          type: 'bar',
          barWidth: '20%',
          data: this.contractsByMonth,
        },
        {
          name: 'Denegados',
          type: 'bar',
          barWidth: '20%',
          data: this.deniedContractsByMonth,
        },
        {
          name: 'Cancelada',
          type: 'bar',
          barWidth: '20%',
          data: this.cancelContractsByMonth,
        },
      ],
    };

    this.pieChartOptions = {
      tooltip: {
        trigger: 'item'
      },
      series: [
        {
          type: 'pie',
          radius: '60%',
          data: this.companies,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
  }

}
